export enum PickingListStatus {
    Accepted = 1,
    NotAccepted = 2
}